var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{attrs:{"fnoname":'920.00',"fnoperiod":'year',"fnotitle":'Декларация для плательщиков единого земельного налога'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }